export default "__VITE_ASSET__0479fd16__"